import { fetchGeolocation } from './api';
import { setCurrencyIfNotChosen } from 'tradera/state/multi-currency/actions';
import { removeShippingCountryCookieIfSwedish } from 'tradera/state/shipping-region/actions';
import { API_ERRORS } from 'tradera/utils/api';
import { logger } from 'packages/logger';
import {
    setIsFetchingGeolocation,
    setGeolocation,
    failedLoadingGeolocation
} from './reducer';

export const getGeolocation = () => async (dispatch, getState) => {
    dispatch(setIsFetchingGeolocation(true));
    const { PUBLIC_GEO_PUBLIC_API_BASE_URL } = getState().environment.variables;
    try {
        const response = await fetchGeolocation(PUBLIC_GEO_PUBLIC_API_BASE_URL);
        const { data } = response;
        dispatch(setGeolocation(data));
        dispatch(setCurrencyIfNotChosen(data.currency));
        dispatch(setIsFetchingGeolocation(false));
        dispatch(removeShippingCountryCookieIfSwedish(data));
        return data;
    } catch (error) {
        switch (error.message) {
            case API_ERRORS.ABORTED:
            case API_ERRORS.CANCELLED:
            case API_ERRORS.NETWORK:
                break;
            default:
                logger(error);
                break;
        }
        dispatch(failedLoadingGeolocation());
    }
};
